import { render, staticRenderFns } from "./control_cumplimientos.vue?vue&type=template&id=0bcff48a"
import script from "./control_cumplimientos.vue?vue&type=script&lang=js"
export * from "./control_cumplimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports